import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "grid" }
const _hoisted_2 = { class: "card p-fluid" }
const _hoisted_3 = { class: "p-field p-grid" }
const _hoisted_4 = /*#__PURE__*/_createVNode("label", { class: "p-col-12 p-mb-2 p-md-2 p-mb-0 p-mb-md-0" }, " 宛名 ", -1)
const _hoisted_5 = { class: "p-col-12 p-md-4" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { class: "p-col-12 p-mb-2 p-md-2 p-mb-0 p-mb-md-0" }, " ※〇〇新聞社　御中 ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_zMessage = _resolveComponent("zMessage")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    header: '新聞社用PDF出力',
    visible: _ctx.mDispDetail,
    "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.mDispDetail = $event)),
    style: [{ width: '80vw' }, {"max-width":"1100px"}],
    modal: true,
    closable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        label: "閉じる",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.fncClose())),
        class: "p-mr-2 p-mt-2",
        style: {"width":"120px"}
      }),
      _createVNode(_component_Button, {
        label: "印刷",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.fncExport())),
        class: "p-mr-2 p-mt-2",
        style: {"width":"120px"}
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_TransitionGroup, {
        name: "z-message",
        tag: "div"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mMessage, (msg) => {
            return (_openBlock(), _createBlock(_component_zMessage, {
              severity: msg.severity,
              key: msg.id
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(msg.content), 1)
              ]),
              _: 2
            }, 1032, ["severity"]))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", _hoisted_3, [
            _hoisted_4,
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_InputText, {
                type: "text",
                modelValue: _ctx.mATENAX,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.mATENAX = $event)),
                maxlength: "20"
              }, null, 8, ["modelValue"])
            ]),
            _hoisted_6
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}